import { BorrowerDashboardComponent } from '@pylonlending/react-elements';
import { useState } from 'react';

// Our Components
import Loader from 'components/Loader/';
import SelectClientViaAdvisor from 'components/ClientSearchViaAdvisor/SelectClientViaAdvisor';

// Our Hooks
import useGetClientPylonId from 'hooks/pylon/useGetClientPylonId';

function PylonBorrowerDashboard() {
	const [selectedClient, setSelectedClient] = useState(null);
	const [selectedAdvisor, setSelectedAdvisor] = useState(null);
	const [selectedLoanApplication, setSelectedLoanApplication] = useState('');

	// Checks
	const hasSelectedAdvisorAndClient = !!selectedAdvisor && !!selectedClient;
	const isGetLoanIdReady =
		selectedAdvisor && selectedClient && selectedLoanApplication;

	const loanId = isGetLoanIdReady && selectedLoanApplication.split(' - ')[1];

	const { isLoading, isSuccess, data } = useGetClientPylonId(
		{
			clientId: selectedClient?.id,
			loanId: loanId ? loanId : null
		},
		hasSelectedAdvisorAndClient && !!selectedLoanApplication
	);

	return (
		<div>
			<SelectClientViaAdvisor
				selectedClient={selectedClient}
				setSelectedClient={setSelectedClient}
				selectedAdvisor={selectedAdvisor}
				setSelectedAdvisor={setSelectedAdvisor}
				selectedLoanApplication={selectedLoanApplication}
				setSelectedLoanApplication={setSelectedLoanApplication}
				labels={{
					selectClientLabel:
						'Select a client to view their loan applications',
					selectClientHelperText:
						'Only clients with existing loan applications will be shown',
					selectLoanApplicationLabel: 'Select a loan application',
					selectLoanApplicationHelperText:
						'This allows you to resume a loan application'
				}}
				loanSelector={(data) => {
					const filteredBySubmitted = data.loanApplications.filter(
						(loanApp) => loanApp.submitted
					);

					const filteredLoanApplications = {
						...data,
						loanApplications: filteredBySubmitted
					};

					return filteredLoanApplications;
				}}
			/>

			<div>
				{isSuccess && (
					<BorrowerDashboardComponent
						loanId={loanId}
						authLeaseCallback={() => {
							const { resp: pylonAuth } = data;
							return pylonAuth;
						}}
					/>
				)}
			</div>
			{isLoading && <Loader />}
		</div>
	);
}

export default PylonBorrowerDashboard;
